import './styles/graphic.scss';
import mapboxgl from 'mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(updateLocale);

dayjs.updateLocale('en', {
  monthsShort: [
    'Jan.', 'Feb.', 'March', 'April', 'May', 'June',
    'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.',
  ],
  meridiem: (hour, minute, isLowercase) => (hour >= 12 ? 'p.m.' : 'a.m.'),
});

const sendHeightIfPym = () => {
  if (typeof window !== 'undefined' && window.pymChild && typeof window.pymChild.sendHeight === 'function') {
    window.pymChild.sendHeight();
  }
};

const drawMap = (container, isMobile) => {
  mapboxgl.accessToken = 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJiYjIwMTgxNDZmNjgyODllMjAxYTYwOTAxYmY2MzI2MyJ9.8F6TQITXymFzCXy8tBqGgg';

  // screen size config
  const optionsSm = {
    initZoom: 2,
    minZoom: 2,
    maxZoom: 4,
    center: [-78, 27],
    maxBounds: [[-110, -10], [-10, 45]],
  };

  const optionsLg = {
    initZoom: 2,
    minZoom: 2,
    maxZoom: 5,
    center: [-50, 20], // Adjusted center of the bounding box
    // maxBounds: [[-100, -10], [-10, 40]], // Adjusted bounding box in [southwest, northeast] format
    maxBounds: [[-110, -10], [-10, 45]], // Adjusted bounding box in [southwest, northeast] format
  };

  const options = isMobile ? optionsSm : optionsLg;

  const map = new mapboxgl.Map({
    container: container.node(),
    style: 'mapbox://styles/cnndigital/clyiay3ni00qf01rb7z9ldlkl',
    center: options.center,
    zoom: options.initZoom,
    maxZoom: options.maxZoom,
    minZoom: options.minZoom,
    maxBounds: options.maxBounds,
    dragPan: {
      maxBounds: options.maxBounds, // Constrain the map panning
    },
  });

  map.dragRotate.disable();
  map.touchZoomRotate.disableRotation();
  map.scrollZoom.disable();

  if (!isMobile) {
    const nav = new mapboxgl.NavigationControl({
      showCompass: false,
    });
    map.addControl(nav, 'top-left');
  }

  // Log the initial zoom level
  // console.log(`Initial zoom level: ${map.getZoom()}`);

  // Add an event listener to log the zoom level whenever it changes
  map.on('zoom', () => {
    // console.log(`Zoom level changed to: ${map.getZoom()}`);
  });

  // Log style load events and errors
  map.on('style.load', () => {
    // console.log('Style loaded');
  });

  map.on('error', (e) => {
    console.error('Error:', e.error);
  });

  // Function to fetch and process data
  const fetchDataAndAddLayer = () => {
    fetch('https://ix.cnn.io/data/sea-temperatures/sea_surface_temp_anomalies.json')
      .then(response => response.json())
      .then((data) => {
        // console.log(data);
        const timestamp = data.noaa_posted_est_str;
        document.getElementById('timestamp').textContent = `Notes: Observation at ${timestamp}. Values derived from five-kilometer satellite sea surface temperature anomalies data.`;
        sendHeightIfPym();
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
      });
  };

  map.on('load', () => {
    fetchDataAndAddLayer();
    sendHeightIfPym();
  });

  map.on('idle', () => {
    sendHeightIfPym();
  });
};

export default function (props, container, isMobile) {
  const {
    initialWidth,
    initialHeight,
  } = props;

  container.html(''); // Clear previous content
  container.append('div')
    .attr('id', 'map')
    .style('width', `${initialWidth}px`)
    .style('height', `${initialHeight}px`);

  drawMap(container.select('#map'), isMobile); // Pass the D3 selection of the map div
}
